export class User {
    // id!: string;
    name!: string;
    password!: string;
   
}